import React, { useEffect } from 'react';
import cookie from 'react-cookies';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { ICitySatellite } from '@r1-frontend/api-domru/api-content/v1/geography/get-cities-satellites';
import { IRegionWithCities } from '@r1-frontend/api-domru/api-content/v1/geography/get-regions/dto/ResponseDto';
import { COOKIE_DOMAIN } from '@r1-frontend/entities/Layout/_deps/constants';
import { TState } from '@r1-frontend/entities/Layout/CitySelectContainer/store/reducer';

import CitySelect from '@r1-frontend/city-select/index';

import { fetchCitiesSatellites, fetchRegionCities, fetchRegionsList, fetchTopCities, saveCity } from './store/actions';

const CitySelectContainer = (): JSX.Element | null => {
    const dispatch = useDispatch();

    const { isOpen: citySelectIsOpen, regions, topCities, satellites, selectedRegion } = useSelector(
        (state: TState) => state.citySelect,
        shallowEqual,
    );

    useEffect(() => {
        if (citySelectIsOpen && isEmpty(regions) && !topCities.length && !satellites.length) {
            dispatch(fetchRegionsList());
            dispatch(fetchTopCities());
            dispatch(fetchCitiesSatellites());
        }
    }, [citySelectIsOpen]);

    const fetchCitiesByRegionId = (region: IRegionWithCities) => {
        dispatch(fetchRegionCities(region));
    };

    const citySelectHandler = (selectedCity?: ICitySatellite) => {
        const expires = new Date();
        expires.setDate(expires.getDate() + 41);

        cookie.save('cityconfirm', 1, {
            expires,
            domain: COOKIE_DOMAIN || 'perm',
            path: '/',
        });

        dispatch(saveCity(selectedCity));
    };

    return (citySelectIsOpen
        ? <CitySelect
            regions={regions}
            topCities={topCities}
            citiesSatellites={satellites}
            onRegionSelect={fetchCitiesByRegionId}
            onCitySelect={citySelectHandler}
            selectedRegion={selectedRegion}
            data-test='city-select'
        />
        : null
    );
};

export default CitySelectContainer;
